const BASE = "https://perfectdigitals.co.uk/wp-content/uploads";
export const posterOf = (src) => `/posters/${src.split("/").pop().replace(".mp4", ".jpg")}`;

export const HERO_VIDEO = `${BASE}/2026/06/01-Zest-Cold-Drink.mp4`;
export const FINAL_CTA_VIDEO = `${BASE}/2026/06/02-MARSHALL.mp4`;

export const PROJECTS = [
  ["NARS — Cream", "PRODUCT VIDEO", "/2026/06/06-NARS-CREAM-V2.mp4"],
  ["Curle", "BRAND FILM", "/2026/06/07-CURLE-V2.mp4"],
  ["House of Light", "CINEMATIC AI", "/2026/06/05-House-of-light-V2.mp4"],
  ["Headphones", "PRODUCT VIDEO", "/2026/06/04-b-Headphones.mp4"],
  ["Zest Cold Drink", "ADVERTISING", "/2026/06/01-Zest-Cold-Drink.mp4"],
  ["VA Drink", "SOCIAL CONTENT", "/2026/06/08-VA-DRINK.mp4"],
  ["Marshall", "BRAND FILM", "/2026/06/02-MARSHALL.mp4"],
  ["Leather Shoe", "PRODUCT VIDEO", "/2026/06/03-Leather-Shoe.mp4"],
  ["Faxe Kondi — Energy", "ADVERTISING", "/2026/06/09-FAXE-KONDI-ENERGY-DRINK.mp4"],
  ["Headphones — Girl", "SOCIAL CONTENT", "/2026/06/10-b-HEADPHONES-GIRL.mp4"],
  ["Haven Insurance", "EXPLAINER", "/2026/07/11-Haven-Insurance.mp4"],
  ["Luxury Villas", "BRAND FILM", "/2026/07/14-Luxury-Villas-Property-Video.mp4"],
].map(([title, category, p], i) => ({ id: i + 1, title, category, src: BASE + p }));

export const GRID_SPANS = [
  "lg:col-span-7 aspect-video",
  "lg:col-span-5 aspect-[4/5] lg:mt-32",
  "lg:col-span-5 aspect-[4/5] lg:-mt-24",
  "lg:col-span-7 aspect-video",
  "lg:col-span-12 aspect-video lg:aspect-[21/9]",
  "lg:col-span-6 aspect-video",
  "lg:col-span-6 aspect-[4/5] lg:mt-24",
  "lg:col-span-4 aspect-[3/4]",
  "lg:col-span-8 aspect-video lg:-mt-20",
  "lg:col-span-5 aspect-[4/5]",
  "lg:col-span-7 aspect-video lg:mt-24",
  "lg:col-span-12 aspect-video lg:aspect-[21/9]",
];

export const STATEMENT_VIDEOS = [
  "/2026/06/04-b-Headphones.mp4",
  "/2026/06/03-Leather-Shoe.mp4",
  "/2026/07/14-Luxury-Villas-Property-Video.mp4",
].map((p) => BASE + p);

export const MARQUEE_WORDS = ["Brand Films", "Product Videos", "Advertising", "Explainers", "Social Content", "AI Presenters", "Cinematic AI", "Multilingual"];

export const MANIFESTO = [
  "A finished production needs every scene to work together.",
  "The story needs structure.",
  "The visuals need direction.",
  "Characters and environments need consistency.",
  "The voice needs to fit.",
  "The pacing needs to feel right.",
  "The brand needs to be recognisable.",
  "And everything needs to come together in the edit.",
];

export const PRODUCE = [
  ["Brand Videos", "Build your brand through powerful visual storytelling created around your identity, message and audience."],
  ["Product Videos", "Bring products to life through environments, concepts and visual sequences without the limitations of a traditional shoot."],
  ["Advertising & Campaign Videos", "Create high-impact video creative for paid social, digital advertising, launches and promotional campaigns."],
  ["Explainer Videos", "Turn services, ideas and complex propositions into clear, engaging visual stories."],
  ["Social Media Videos", "Create short-form branded content for Instagram, LinkedIn, TikTok, YouTube and other social platforms."],
  ["AI Presenter Videos", "Presenter-led videos created using realistic AI presenters, professional voice production and supporting visual content."],
  ["Cinematic AI Videos", "Create visual concepts, environments and scenes that would traditionally require significantly larger production resources."],
  ["Multilingual Videos", "Adapt content for different countries, languages and audiences without rebuilding the entire production."],
];

export const STATEMENT_LINES = [
  "Products that don't exist yet.",
  "Locations you can't access.",
  "Worlds you can't build.",
  "Shots that would traditionally require large crews, locations and production budgets.",
];

export const BEYOND = [
  ["Creative Direction", "We develop the overall concept, visual direction and creative approach around your objective."],
  ["Scriptwriting", "Your message is structured into a script designed around the audience, platform and purpose of the video."],
  ["AI Visual Production", "We generate and refine scenes, characters, environments and visual sequences required for the production."],
  ["Voice Production", "Professional AI voiceovers selected and directed around the tone and style of the video."],
  ["Brand Integration", "Your identity, typography, colours, messaging and visual language are incorporated into the final production."],
  ["Professional Editing", "Scenes are selected, structured and refined into a cohesive finished video."],
  ["Motion & Graphics", "Titles, transitions, graphics and visual elements are added where required."],
  ["Music & Sound", "Music, effects and sound design are used to complete the overall production."],
  ["Human Quality Control", "Every production is reviewed and refined by our team before it reaches the client."],
];

export const BENEFITS = [
  ["More Creative Freedom", "Create visual concepts that would traditionally be difficult, expensive or impossible to produce."],
  ["Less Production Overhead", "Reduce the dependency on physical shoots, studios, locations, crews, equipment and complex production logistics."],
  ["Faster Production Workflows", "Produce video through a digital-first workflow while maintaining human creative direction and professional post-production."],
  ["Built to Scale", "Create a single video or build an ongoing production pipeline for campaigns, advertising and social content."],
];

export const STEPS = [
  ["Brief", "Tell us what you want to create, your objective, audience, references and where the video will be used."],
  ["Scope", "We define the creative direction, duration, deliverables, production requirements and final quotation."],
  ["Approve & Pay", "Once the scope and quotation are approved and payment is received, the project moves into production."],
  ["Production", "Our team handles scripting, creative direction, AI generation, voice, editing and post-production."],
  ["Review", "The production is shared with you for feedback and revisions within the agreed project scope."],
  ["Final Delivery", "Your finished video is delivered ready to publish across the required platforms."],
];

export const MODELS = [
  ["One-Off Projects", ["Brand films", "Campaign launches", "Product launches", "Website videos", "Advertising creatives", "Corporate videos"]],
  ["Ongoing Video Production", ["Monthly social content", "Multiple advertising creatives", "Product content", "Campaign production", "International versions", "Continuous video requirements"]],
];

export const CURRENCY = "£";
export const PLANS = [
  { name: "Short Production", dur: "Up to 30 seconds", price: 895, cta: "Scope This Production" },
  { name: "Core Production", dur: "Up to 60 seconds", price: 1495, cta: "Scope This Production", featured: true },
  { name: "Extended Production", dur: "Up to 90 seconds", price: 2095, cta: "Scope This Production" },
  { name: "Custom Production", dur: "90 sec+ / Multiple videos / Campaigns", cta: "Discuss Your Project" },
];

export const INCLUDED = [
  "Creative direction", "Concept development", "Scriptwriting", "AI-generated visual production", "Scene development and refinement",
  "Visual consistency management", "Professional AI voiceover", "Brand integration", "Music", "Sound design where required",
  "Motion graphics and titles where required", "Professional editing", "Post-production", "Human creative review and quality control", "2 revision rounds",
];
